export class DojoAPIWs {
	constructor(path="/rpc/DojoAPI/json/ws", server="") {
		if (""== server) {
			server = "ws" +
				 ("https:" == document.location.protocol ? "s" : "") +
				 "://" +
				 document.location.host
		}
		this._id = 0;
		this.url = server+path;
		this.live = {};
		this.queue = [];
		this.setRPCErrorHandler(null);
		this.startWs();
	}	
	setRPCErrorHandler(_errorHandler=null) {
		this._errorHandler = _errorHandler;
	}
	_reject (reject,err) {
		if (null!=this._errorHandler) {
			this._errorHandler(err);
		}
		reject(err);
		return;
	}
	startWs() {
		this.ws = new WebSocket(this.url);
		this.ws.onmessage = (evt)=> {
			let log = console.error ? console.error : console.log;
			let res = false;
			try {
				res = JSON.parse(evt.data);
			} catch (err) {
				log(`Failed to parse JSON response:`, evt.data);
				return;
			}
			if (undefined == res || undefined==res.id) {
				log(`Failed to parse response: ${evt.data}`);
				return;
			}
			let promise = this.live[res.id];
			if (undefined == promise) {
				log(`Failed to find promise for ${evt.data}`);
				return;
			}
			delete this.live[res.id];
			if (null!=res.error) {
				this._reject(promise.reject, res.error);
				return;
			}
			if (null!=res.result) {
				promise.resolve(res.result);
				return;
			}
			promise.resolve(null);
		};
		this.ws.onerror = (err)=> {
			console.error("ERROR on websocket:", err);
		};
		this.ws.onopen = (evt)=> {
			console.log("Connected websocket");
			for (let q of this.queue) {
				this.ws.send(q);
			}
			console.log(`Emptied queue of ${this.queue.length} queued messages`);
			this.queue = [];
		};
		this.ws.onclose = (evt)=> {
			console.log("Websocket closed - attempting reconnect in 1s");
			setTimeout( ()=> this.startWs(), 1000 );
		}
	}
	_rpc(method, params) {
		let id = this._id++;
		// params comes in as an 'arguments' object, so we need to convert
		// it to an array
		params = Array.prototype.slice.call(params);
		// let p = [];
		// for (let i=0; i<p.length; i++) {
		// 	p[i] = params[i]
		// }

		let data = JSON.stringify({ id:id, method:method, params:params })
		this.live[id] = {
			resolve: null,
			reject: null
		};
		return new Promise( (resolve,reject)=> {
			this.live[id].resolve = resolve;
			this.live[id].reject = reject;
			if (1==this.ws.readyState) {
				this.ws.send(data);
			} else {
				this.queue.push(data);
			}
		});
	}

	
	Error () {
		return this._rpc("Error",  arguments );
	}
	
	LoginUser (emailOrMobile,password) {
		return this._rpc("LoginUser",  arguments );
	}
	
	Logout () {
		return this._rpc("Logout",  arguments );
	}
	
	StudentResetPasswordByEmailOrMobile (emailOrMobile) {
		return this._rpc("StudentResetPasswordByEmailOrMobile",  arguments );
	}
	
	StudentRegisterByEmailOrMobile (emailOrMobile) {
		return this._rpc("StudentRegisterByEmailOrMobile",  arguments );
	}
	
	NewDojo (name,parentId,offset) {
		return this._rpc("NewDojo",  arguments );
	}
	
	GetDojo (id) {
		return this._rpc("GetDojo",  arguments );
	}
	
	SaveDojo (d) {
		return this._rpc("SaveDojo",  arguments );
	}
	
	DeleteDojo (dojo) {
		return this._rpc("DeleteDojo",  arguments );
	}
	
	DeleteClassRecord (classRecordId) {
		return this._rpc("DeleteClassRecord",  arguments );
	}
	
	DojosForUser () {
		return this._rpc("DojosForUser",  arguments );
	}
	
	ClassTypes () {
		return this._rpc("ClassTypes",  arguments );
	}
	
	SetClassRecordNotes (classRecordId,notes) {
		return this._rpc("SetClassRecordNotes",  arguments );
	}
	
	SetClassRecordTitle (classRecordId,title) {
		return this._rpc("SetClassRecordTitle",  arguments );
	}
	
	SetClassRecordType (classRecordId,classTypeId) {
		return this._rpc("SetClassRecordType",  arguments );
	}
	
	SetClassRecordTimes (crId,dateString,startString,endString) {
		return this._rpc("SetClassRecordTimes",  arguments );
	}
	
	StudentAttendanceForClassRecord (crId) {
		return this._rpc("StudentAttendanceForClassRecord",  arguments );
	}
	
	StudentAbsenceForClassRecord (crId) {
		return this._rpc("StudentAbsenceForClassRecord",  arguments );
	}
	
	StudentsForClassRecord (crId) {
		return this._rpc("StudentsForClassRecord",  arguments );
	}
	
	AddStudentToClassRecord (classRecordId,studentId,attendanceTypeId) {
		return this._rpc("AddStudentToClassRecord",  arguments );
	}
	
	RemoveStudentFromClassRecord (classRecordId,studentId) {
		return this._rpc("RemoveStudentFromClassRecord",  arguments );
	}
	
	SetStudentClassRecordAttendanceType (classRecordId,studentId,attendanceTypeId) {
		return this._rpc("SetStudentClassRecordAttendanceType",  arguments );
	}
	
	AttendanceTypes () {
		return this._rpc("AttendanceTypes",  arguments );
	}
	
	AttendanceTypesWithAbsence () {
		return this._rpc("AttendanceTypesWithAbsence",  arguments );
	}
	
	LoadTechniques () {
		return this._rpc("LoadTechniques",  arguments );
	}
	
	TechniqueSearch (classRecordId,techniqueSearch) {
		return this._rpc("TechniqueSearch",  arguments );
	}
	
	AddTechniqueToClassRecord (classRecordId,technique) {
		return this._rpc("AddTechniqueToClassRecord",  arguments );
	}
	
	RemoveTechniqueFromClassRecord (classRecordId,technique) {
		return this._rpc("RemoveTechniqueFromClassRecord",  arguments );
	}
	
	LoadClassRecordTechniques (classRecordId) {
		return this._rpc("LoadClassRecordTechniques",  arguments );
	}
	
	ClassRecordSummaryForPeriod (dojoId,start,end) {
		return this._rpc("ClassRecordSummaryForPeriod",  arguments );
	}
	
	ClassRecordSummarySearch (search) {
		return this._rpc("ClassRecordSummarySearch",  arguments );
	}
	
	DojoAttendanceByDate (dojoId) {
		return this._rpc("DojoAttendanceByDate",  arguments );
	}
	
	StudentAttendanceByDate (studentId) {
		return this._rpc("StudentAttendanceByDate",  arguments );
	}
	
	DeleteAspect (aspectId) {
		return this._rpc("DeleteAspect",  arguments );
	}
	
	LoadTechniquesForArtLimited (artId,from,to) {
		return this._rpc("LoadTechniquesForArtLimited",  arguments );
	}
	
	LoadTechniquesForArt (artId) {
		return this._rpc("LoadTechniquesForArt",  arguments );
	}
	
	DeleteTechnique (techniqueId) {
		return this._rpc("DeleteTechnique",  arguments );
	}
	
	SaveTechnique (t) {
		return this._rpc("SaveTechnique",  arguments );
	}
	
	DeleteStudent (dojoId,studentId) {
		return this._rpc("DeleteStudent",  arguments );
	}
	
	FormsForDojo (dojoId) {
		return this._rpc("FormsForDojo",  arguments );
	}
	
	FormsAndInputsForDojoRefType (dojoId,refType,refId) {
		return this._rpc("FormsAndInputsForDojoRefType",  arguments );
	}
	
	FormsForDojoRefType (dojoId,refType) {
		return this._rpc("FormsForDojoRefType",  arguments );
	}
	
	SaveForm (f) {
		return this._rpc("SaveForm",  arguments );
	}
	
	LoadFormInput (formId,refId) {
		return this._rpc("LoadFormInput",  arguments );
	}
	
	SaveFormInput (fi) {
		return this._rpc("SaveFormInput",  arguments );
	}
	
	DeleteForm (formId) {
		return this._rpc("DeleteForm",  arguments );
	}
	
	SendShortMessage (toIds,txt) {
		return this._rpc("SendShortMessage",  arguments );
	}
	
	SendEmailMessage (toIds,title,text) {
		return this._rpc("SendEmailMessage",  arguments );
	}
	
	StudentById (studentId) {
		return this._rpc("StudentById",  arguments );
	}
	
	StudentsForDojo (dojoId) {
		return this._rpc("StudentsForDojo",  arguments );
	}
	
	MergeTechniques (fromId,toId) {
		return this._rpc("MergeTechniques",  arguments );
	}
	
	StudentAttendance (studentId,dojoId,dates) {
		return this._rpc("StudentAttendance",  arguments );
	}
	
	StudentAttendanceSearch (sas) {
		return this._rpc("StudentAttendanceSearch",  arguments );
	}
	
	Version () {
		return this._rpc("Version",  arguments );
	}
	

	flatten(callback, context=null) {
		return function(argsArray) {
			callback.apply(context, argsArray);
		}
	}
}

// Define the class in the window and make AMD compatible
window.DojoAPIWs = DojoAPIWs;
if (("function" == typeof window.define) && (window.define.amd)) {
	window.define("DojoAPIWs", [], function() { return window.DojoAPIWs; });
}
